import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    amount: z.number(),
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
